<template>
    <VCardText>
        <VList class="mb-4">
            <VListItem v-for="item in props.data.possible_distributors" :key="item.distributor.slug"
                :value="item.distributor.slug">
                <template #prepend>
                    <VAvatar color="secondary" style="text-transform: uppercase">
                        {{ `${item.distributor.name[0]}${item.distributor.name[1]}` }}
                    </VAvatar>
                </template>
                <VListItemTitle>
                    {{ item.distributor.name }}
                </VListItemTitle>
                <template #append>
                    <VBtn :id="item.distributor.slug" size="small" :data-testid="`distributor-${item.distributor.slug}`"
                        @click="beforeSubmit(item)" :loading="isLoading" :disabled="item.distributor.slug === slug">
                        {{ $t('auth.distributor.change') }}
                    </VBtn>
                </template>
            </VListItem>
        </VList>
    </VCardText>
</template>

<script setup>
    import _ from 'lodash'
    const props = defineProps(['data', 'onSubmit'])
    const isLoading = ref(false)
    const slug = localStorage.getItem('slug')

    async function beforeSubmit(slug) {
        isLoading.value = true
        try {
            await props.onSubmit(slug)
        } catch (err) {}
        isLoading.value = false
    }
</script>